import { render, staticRenderFns } from "./urgency_new.vue?vue&type=template&id=3b02b6ca&"
import script from "./urgency_new.vue?vue&type=script&lang=js&"
export * from "./urgency_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports